module.exports = __webpack_public_path__ + "img/aeab878.png";